var fallbackFontFamily = "Arial, Helvetica, sans-serif, \"Segoe UI Emoji\", \"Segoe UI Symbol\"";

/**
 * For most body styles.
 */
export var interFontFamily = "\"Inter\", ".concat(fallbackFontFamily);
export var interVarFontFamily = "\"Inter var\", ".concat(fallbackFontFamily);

/**
 * An incorrectly-named font-family that we are using all over the place...
 * @deprecated Please use ttNormsVarFontFamily or ttNormsFontFamily.
 */
export var ttNormsProBoldFontFamily = "\"TT Norms Pro Bold\", ".concat(fallbackFontFamily);

/**
 * For some headings and other text that needs to be a bit bolder.
 */
export var ttNormsFontFamily = "\"TT Norms Pro\", ".concat(fallbackFontFamily);
export var ttNormsVarFontFamily = "\"TT Norms Pro var\", ".concat(fallbackFontFamily);
//# sourceMappingURL=fonts.js.map